<template>
  <base-login success-path="/console/dashboard">
  </base-login>
</template>

<script>
import baseLogin from '@/views/base/page/LoginDynamicImg.vue'
export default {
  name: 'consoleLogin',
  components: {
    baseLogin
  },
  data() {
    return {
    }
  },
  mounted() {
  },
  methods: {
  }
}
</script>

<style lang="scss">
</style>
